/**
 * @Author: Ygm
 * @Date: 2024-08-08 09:57:48
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-13 15:40:04
 * @Description: 录入空间->信息类别
 */
import { request } from '@/utils/request'

const suffix = '/api/infoInput'

/**
 * @description 获取信息类别列表
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getInfoCategory = (data = {}) => {
  const url = `${suffix}/get/infoCategorList`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 新增/编辑信息类别
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const addOrUpdateCategory = (data = {}) => {
  const url = `${suffix}/addOrUpdate/infoCategory`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 删除信息类别
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const deleteCategory = (data = {}) => {
  const url = `${suffix}/delete/infoCategory`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

/**
 * @description 获取所属工作组下拉列表
 * @param {object} data 入参
 * @returns {Promise<unknown>}
 */
const getWorkgroupList = (data = {}) => {
  const url = `/api/base/project/getWorkgroupByUserSpy`
  return new Promise((resolve, reject) => {
    request(url, data, resolve, reject)
  })
}

export { getInfoCategory, addOrUpdateCategory, deleteCategory, getWorkgroupList }



// WEBPACK FOOTER //
// ./src/apis/inputSpace/infoCategory.js